import script from "./var-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./var-list.vue?vue&type=script&lang=ts&setup=true"

import "./var-list.vue?vue&type=style&index=0&id=b75b0cce&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\yang'ya'fei\\Documents\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b75b0cce"]])

export default __exports__